'use client'

import useAnimatedRouter from "@/hooks/useAnimatedRouter";
import useFormInitialStore from "@/store/form_initial";
import React, { Ref } from "react";
import { createAnswers } from "@/utils/client/client_api";

type NavigationButtonsProps = {
    next?: string;
    text: string;
    stepIsValidated: boolean;
    completedQuestion: string;
    completedAnswer?: any;
    onClick?: () => Promise<boolean> | boolean;
    color?: string;
    width?: string;
    margin?: string;
    ref?: Ref<HTMLButtonElement>;
    externalRoute?: string;
};

export const NavigationButtons = ({
    next,
    stepIsValidated,
    text,
    completedQuestion,
    completedAnswer,
    onClick,
    color,
    width,
    margin,
    ref,
    externalRoute
}: NavigationButtonsProps) => {

    const { addCompletedQuestion } = useFormInitialStore();
    const { animatedRoute } = useAnimatedRouter();

    const [isLoading, setIsLoading] = React.useState(false);

    const sendAnswer = async () => {
        const answers = [{
            question: completedQuestion,
            answer: JSON.stringify(completedAnswer) ?? '',
        }];
        if (completedAnswer) {
            Object.keys(completedAnswer).forEach(key => {
                answers.push({
                    question: key,
                    answer: completedAnswer[key] ?? ''
                })
            })
        }

        await createAnswers({
            answers: answers,
        });
    }

    const handleClick = async () => {

        setIsLoading(true);

        try {

            if (externalRoute) {
                if (window.self !== window.top) {
                    window.open(externalRoute, "_parent");
                } else {
                    window.open(externalRoute, "_blank");
                }
                return;
            }

            if (next) {
                if (onClick === undefined) {
                    addCompletedQuestion(completedQuestion)
                    sendAnswer();
                    animatedRoute(next);
                } else {
                    const result = await onClick();
                    if (result) {
                        addCompletedQuestion(completedQuestion)
                        sendAnswer();
                        animatedRoute(next);
                    }
                }
            }
        } catch (e) {
            console.error(e)
        } finally {
            setIsLoading(false)
        }
    }

    const renderClass = () => {

        const widthClass = width ? `${width}` : '';
        const marginClass = margin ? `${margin}` : '';

        let colorClass = '';
        if (color && color === 'blue') {
            if (!stepIsValidated) {
                colorClass = 'bg-blueH4 text-smokeH';
            } else {
                colorClass = 'bg-blueH1 hover:bg-blueH2 text-smokeH';
            }
        } else {
            if (!stepIsValidated) {
                if (color === 'inverted') {

                    colorClass = 'bg-smokeH border-4 border-primaryBlue200';
                } else {

                    colorClass = 'bg-primaryBlue200 text-smokeH';
                }
            } else {
                if (color === 'inverted') {

                    colorClass = 'bg-smokeH border-4 border-primaryBlue700 text-primaryBlue700 hover:bg-primaryBlue700 hover:text-smokeH';
                } else {
                    colorClass = 'bg-primaryBlue700 hover:bg-primaryBlue600 text-smokeH';

                }
            }
        }
        return `${widthClass} ${marginClass} ${colorClass}`.trim();
    };
    return (
        <div className="flex justify-center w-full">
            <button
                type="button"
                ref={ref}
                id="navigationButtonId"
                aria-label="go forward"
                onClick={handleClick}
                disabled={isLoading || !stepIsValidated}
                className={`rounded-lg  flex justify-center items-center font-semibold p-4 w-full text-lg  ${renderClass()}`}
            >
                {text}
            </button>
        </div>
    );
};
